<template>
  <v-container>
    <v-data-table
          v-bind:headers="headers"
          :items="items"
          :hide-default-footer="true"
          class="elevation-1"
          :no-data-text="$t('common.noDevicesConnected')"
        >
           <template v-slot:item="{ item }">
           <tr @click="Grafici()">
                <td><v-icon large color="black" >mdi-delete-variant</v-icon></td>
                <td><v-icon :style="item.stato == 'red' ? 'color: red;' : 'color: green;'">mdi-checkbox-blank-circle</v-icon></td>
                <td>{{ item.name }}</td>
                <td>{{ item.building }}</td>
                <td>{{ item.piano }}</td>
                <td><v-icon :style="item.signal == 'ko' ? 'color: red;' : 'color: green;'" >mdi-wifi</v-icon></td>
           </tr>
           </template>
        </v-data-table>
  </v-container>
</template>

<script>

export default {
  name: 'HomeView',
  data(){
    return{
      pagination: { 'sortBy': 'name', 'descending': true, rowsPerPage: 25 },
      selected: [],
      items: [{ name: "Cestino bagno proprietà", piano: "terzo piano", building: "YouTissue", stato: "green", signal: "ok"},
              { name: "Cestino bagno dipendenti",  piano: "primo piano", building: "YouTissue", stato: "red", signal: "ok"},
              { name: "Cestino bagno ospiti", piano: "secondo piano", building: "YouTissue", stato: "green", signal: "ko"},
              { name: "Cestino bagno dipendenti", piano: "terzo piano", building: "YouTissue", stato: "red", signal: "ko"}],
    }
  },
  computed: {
    headers() {
      return [
        { text: this.$t('manageSensors.type'), align: "center", value: "type"},
        { text: this.$t('sensorDetails.status'), align: "center", value: "stato" },
        { text: this.$t('manageSensors.name'), align: "center", value: "name" },
        { text: this.$t('manageSensors.building'), align: "center", value: "building" },
        { text: this.$t('manageSensors.floor'), align: "center", value: "piano" },
        { text: "Signal", align: "center", value: "signal" } 
      ]
    }
  },
  methods: {
    Grafici(){
      this.$router.push({ path: `/grafici` });
    }
  }
}
</script>
